import { render, staticRenderFns } from "./ShowClientFeedbackRequest.vue?vue&type=template&id=72436bec"
import script from "./ShowClientFeedbackRequest.vue?vue&type=script&lang=js"
export * from "./ShowClientFeedbackRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports